import { render, staticRenderFns } from "./dashboardItem.vue?vue&type=template&id=5e9ac7d4&scoped=true"
import script from "./dashboardItem.vue?vue&type=script&lang=js"
export * from "./dashboardItem.vue?vue&type=script&lang=js"
import style0 from "./dashboardItem.vue?vue&type=style&index=0&id=5e9ac7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9ac7d4",
  null
  
)

export default component.exports